import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../domain/planning/user';
import { Permissions } from '../domain/user-profile/permissions';
import { CoreData } from '../tools/core-data';
import { LoadingTask } from '../tools/loading-task';
import { BaseService } from './base-service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class UserService extends BaseService {

    private serviceUrl = `${environment.serviceMainBaseUrl}api/user`;

    constructor(protected http: HttpClient,
        protected coreData: CoreData,
        protected loadingTask: LoadingTask,
        protected snackBare: MatSnackBar,
        protected router: Router,
        ) {

        super(coreData, router, snackBare);
    }

    getAll() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/all`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('geAll')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: User[]) => {
                return response.map((item: User) => {
                    return User.mapFromJSON(item);
                });
            }));
    }

    // Data from EnvFrServices proxyed by own application server
    getRolePermissions() {
            this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/Role`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getRoles')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Permissions[]) => {
                return response.map((item: Permissions) => {
                    return Permissions.mapFromJSON(item);
                });
            }));
    }
    
}
